import { useEffect, useState } from "react";
import styled from "styled-components";
import { SuccessButton, WarningButton } from "../styles/button";
import { JokeModel } from "../models/joke";
import { Translate } from "../components/translate";
import { useLanguage } from "../stores/language_store";

export function Joke() {
  const [joke, setJoke] = useState<JokeModel>();
  const [answerHidden, setAnswerHidden] = useState(true);
  const language = useLanguage();

  function fetchJoke() {
    let lang = "fr";
    if (language === "english") {
      lang = "en";
    }
    setAnswerHidden(true);
    setJoke(undefined);
    fetch(`https://v2.jokeapi.dev/joke/Any?lang=${lang}`)
      .then((response) => response.json())
      .then((data) => setJoke(data));
  }
  useEffect(() => fetchJoke(), []);
  console.log(joke);

  return (
    <Container>
      <SuccessButton onClick={() => fetchJoke()}>
        <Translate value="newJoke" />
      </SuccessButton>
      {joke === undefined ? (
        <Text>Loading...</Text>
      ) : (
        <>
          <Text>{joke.setup}</Text>
          <WarningButton onClick={() => setAnswerHidden(false)}>
            <Translate value="response" />
          </WarningButton>
          {answerHidden ? <></> : <Text>{joke.delivery}</Text>}
        </>
      )}
    </Container>
  );
}

const Container = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

const Text = styled.div`
  font-size: 20px;
  text-align: center;
`;
